var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntune(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6572_133008)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4047 13.009L15.246 11.6661L13.4047 10.3233V13.009ZM11.0806 13.8147C8.27387 13.8147 8.48843 13.367 8.48843 11.6662H7.32651H6.16443C6.16443 13.3672 6.37883 13.8149 3.57227 13.8149V14.531H11.0806V13.8147ZM7.32651 9.14165C7.17655 9.14252 7.0279 9.11352 6.88911 9.05632C6.75032 8.99913 6.62413 8.91486 6.5178 8.80836C6.41147 8.70187 6.32709 8.57526 6.26952 8.4358C6.21195 8.29635 6.18232 8.14681 6.18235 7.99578C6.18235 7.35122 6.70075 6.83203 7.32651 6.83203C7.97003 6.83203 8.48843 7.35122 8.48843 7.99578C8.47051 8.64034 7.95211 9.14165 7.32651 9.14165Z",
    fill: "#0072C5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4043 13.0991L15.2456 11.6667L13.4043 10.2344V13.0991Z",
    fill: "#0072C5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9407 12.1149V11.2196H2.14197V4.77404H12.5106V7.19113H13.4045V4.41598C13.4045 4.14736 13.1364 3.87891 12.8682 3.87891H1.78437C1.51621 3.87891 1.24805 4.14753 1.24805 4.41598V11.5778C1.24805 11.8465 1.51621 12.1149 1.78437 12.1149H6.16437C6.18213 13.4577 6.12853 13.8159 3.57221 13.8159V14.532H11.0805V13.8159C8.52421 13.8159 8.47045 13.4579 8.48837 12.1149H13.9407ZM16.2648 7.54934H8.38101C8.20229 7.13747 7.79109 6.85097 7.32629 6.85097C6.68261 6.85097 6.16421 7.37032 6.16421 7.99683C6.16421 8.62334 6.68261 9.14269 7.32629 9.14269C7.80901 9.14269 8.22005 8.85619 8.38101 8.44431H15.9967V15.0689H12.4213V12.473H11.7063V15.7854C11.7063 16.0359 11.9029 16.233 12.1532 16.233H16.2648C16.5151 16.233 16.7117 16.0361 16.7117 15.7854V7.99683C16.7117 7.7461 16.5151 7.54934 16.2648 7.54934ZM14.6559 15.7854H13.7621V15.5167H14.6559V15.7854Z",
    fill: "#0072C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6572_133008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.980469 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntune);
export default __webpack_public_path__ + "static/media/Intune.77a097bfaf50f3ffe3f5c0dd50477b5f.svg";
export { ForwardRef as ReactComponent };